import type { Column } from '@talos/kyoko';

export const columns: Column[] = [
  { field: 'TransactTime', title: 'Date', type: 'date', initialSort: '-' },
  { field: 'Side', type: 'side' },
  { field: 'Symbol', type: 'security' },
  { field: 'Quantity', type: 'size', params: { currencyField: 'Currency' } },
  { field: 'Price', type: 'price', params: { quoteCurrencyField: 'QuoteCurrency' } },
  {
    field: 'PriceAllIn',
    type: 'price',
    title: 'Filled Price All-In',
    params: { assetField: 'Symbol' },
    initialHide: true,
  },
  { field: 'Amount', type: 'size', params: { currencyField: 'AmountCurrency' } },
  { field: 'Fee', type: 'size', params: { currencyField: 'FeeCurrency' } },
  { field: 'User', type: 'user' },
  { field: 'TradeID', type: 'id' },
  { field: 'MarketAccount', type: 'marketAccount' },
  { field: 'Market', type: 'market', initialHide: true },
  { field: 'SubAccount', type: 'subAccount' },
  { field: 'Group', type: 'group', initialHide: true },
  { field: 'OrderID', type: 'id', initialHide: true },
  { field: 'MarketTradeID', type: 'id', initialHide: true },
  { field: 'Timestamp', type: 'date', initialHide: true },
  { field: 'TradeStatus', title: 'Status', type: 'tradeStatus' },
  { field: 'AggressorSide', type: 'side', initialHide: true },
  { field: 'Comments', type: 'text' },
  { field: 'AllocationID', type: 'id', initialHide: true },
  { field: 'MarketOrderID', type: 'id', initialHide: true },
  { field: 'MarketExecID', type: 'id', initialHide: true },
  { field: 'ParentTradeID', type: 'id', initialHide: true },
  { field: 'QuoteID', type: 'id', initialHide: true },
  { field: 'RFQID', type: 'id', initialHide: true },
  { field: 'TalosFee', type: 'size', params: { currencyField: 'TalosFeeCurrency' }, initialHide: true },
  { field: 'TradeSource', type: 'text', initialHide: true },
];
